import React, { useContext } from "react"
import { FirebaseContext } from "../Firebase"
import { Dropdown } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import ProfileImage from "../profile-image/profile-image.js"
import Link, { navigate } from "../../link"
import "./AccountDropdown.css"
import "bootstrap/dist/css/bootstrap.min.css"

/**
 * Dropdown in a student's nav bar used to navigate between the dashbard, the
 * account information page, and logging out
 * @param {Function} afterLogout - runs after the current user logs out
 * @returns {JSX}
 */
const AccountDropdown = ({ afterLogout = () => null }) => {
  const { firebase, profile } = useContext(FirebaseContext)

  const handleLogout = async (e) => {
    e.preventDefault()

    const now = new Date()

    try {
      // These need to be chained so that the update profile finishes
      // before the user is logged out (updateProfile is not async)
      await firebase
        .updateProfile({ data: { logoutDate: now } })
        .then(firebase.logout())
        .then(navigate("/"))
    } catch (e) {
      console.error(e)
    }

    afterLogout()
  }

  return (
    <div className="account-dropdown printer-none profile-container">
      <div className="profile-header">
        <Dropdown alignRight>
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <div>
              <ProfileImage profile={profile} className="header-profile-image"/>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item as={Link} to="/dashboard" className="dropdown-item">
              <FormattedMessage id="account-menu-my-dashboard" defaultMessage="My Dashboard" />
            </Dropdown.Item>
            <Dropdown.Item as={Link} to="/member/account" className="dropdown-item">
              <FormattedMessage id="account-menu-my-account" defaultMessage="My Account" />
            </Dropdown.Item>
            <Dropdown.Item as={Link} to="/" onClick={handleLogout} className="dropdown-item">
              <FormattedMessage id="account-menu-logout" defaultMessage="Logout" />
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  )
}

export default AccountDropdown
